import { render, staticRenderFns } from "./VehicleDetailMovemnt.vue?vue&type=template&id=084f0616&scoped=true"
import script from "./VehicleDetailMovemnt.vue?vue&type=script&lang=js"
export * from "./VehicleDetailMovemnt.vue?vue&type=script&lang=js"
import style0 from "./VehicleDetailMovemnt.vue?vue&type=style&index=0&id=084f0616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084f0616",
  null
  
)

export default component.exports